import React from 'react'
import { StatusBadge } from '../views/CheckoutSessions'
import { SectionItem, SubTitle } from '../components/Shared'

export const MDASH = '\u2014'

// ---------------------------------------------------------------------------------------------------------------------
export interface columnData {
  heading: string
  content: any
}

const isColumnData = (item: React.ReactElement | columnData): item is columnData =>
  typeof item === 'object' && 'heading' in item && 'content' in item

// ---------------------------------------------------------------------------------------------------------------------
// Render a `columnData` object
const genSectionItem = (el: columnData, rowIdx: number, colIdx: number): React.ReactElement =>
  <SectionItem>
    { el.heading && el.heading === 'Status' &&
      <StatusBadge status={el.content}>{el.content}</StatusBadge>
    }
    { el.heading && el.heading !== 'Status' &&
      <>
        <SubTitle>{el.heading}</SubTitle>
        <span>{el.content ?? MDASH}</span>
      </>
    }
  </SectionItem>

// ---------------------------------------------------------------------------------------------------------------------
// Transform an array of `(columnData | ReactElement)` into an array of <SectionItem> elements
//
// If `colCount` is missing, then the default column count is 3
//
// If `colCount` consecutive elements are empty, then that row will be skipped
export const genSectionItems =
(items: Array<columnData | React.ReactElement>, colCount: number | undefined): React.ReactElement[] => {
  const cols = colCount || 3
  const elAcc: React.ReactElement[] = []

  for (let rowIdx = 0; rowIdx < items.length; rowIdx += cols) {
    const rowItems = items.slice(rowIdx, rowIdx + cols)

    // Check for empty row
    if (rowItems.filter(el => Boolean(isColumnData(el) ? el.content : el)).length === 0) {
      continue
    } else {
      rowItems.reduce((acc, el, colIdx) => {
        acc.push(isColumnData(el) ? genSectionItem(el, rowIdx, colIdx) : el)
        return acc
      }, elAcc)
    }
  }

  return elAcc
}
